var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.existingSubscriptions && _vm.existingSubscriptions.length > 0
        ? _c(
            "b-row",
            {
              staticClass: "mb-0 pb-0 current-plan",
              attrs: { "align-h": "center", "no-gutters": "" }
            },
            [
              _c("b-col", [
                _c(
                  "div",
                  {
                    staticClass: "row mb-3 ml-3 mr-3",
                    attrs: { "align-h": "around" }
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass: "text-center plan-details-header",
                        attrs: { "data-test-hook": "current-plan-support-text" }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("xCurrentPlanSupport", {
                                0: _vm.existingSubscriptions[0].product.name
                              })
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _c("SubscriptionCard", {
        attrs: {
          "subscription-product": _vm.existingSubscriptions[0].product,
          "existing-apparatuses": _vm.subscriptionApparatusData,
          "apparatuses-to-add": [_vm.apparatusDetails],
          "is-new-plan": false,
          "are-all-covered": true
        }
      }),
      _c(
        "b-row",
        { staticClass: "mt-3", attrs: { "no-gutters": "" } },
        [
          _c(
            "b-col",
            { staticClass: "float-left pl-2", attrs: { cols: "12" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "w-100",
                  attrs: {
                    variant: "warning",
                    disabled: _vm.subscribing,
                    "data-test-hook":
                      "existing-subscription-modal-confirm-plan-button"
                  },
                  on: { click: _vm.addApparatusToSubscription }
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("xContinue")) + " "),
                  _vm.subscribing
                    ? _c("b-spinner", { staticClass: "ml-2" })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.showSelectSubError
        ? _c(
            "div",
            {
              staticClass: "alert alert--validation alert-danger",
              attrs: { show: _vm.showSelectSubError }
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("xFailedSetUpGeneratorSubscription")) + " "
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }